let LOAD_REASON;

const handlers = new Set();

const handleLoadReason = () => {
  for (const handler of handlers) {
    handler(LOAD_REASON);
  }
};

export const onLoadReason = (handler) => {
  if (typeof handler !== 'function') {
    return;
  }

  handlers.add(handler);

  if (LOAD_REASON) {
    setImmediate(() => handler(LOAD_REASON));
  }
};

export const removeHandler = (handler) => {
  handlers.delete(handler);
};

export const setLoadReason = (loadReason) => {
  LOAD_REASON = loadReason;
  handleLoadReason();
}



// WEBPACK FOOTER //
// ./src/lib/load-reason.js